module.exports = __webpack_public_path__ + "img/014.1abe95a2.jpg";